/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'booking.summary.title',
    defaultMessage: 'Request complete',
  },
  thanks: {
    id: 'booking.summary.thanks',
    defaultMessage:
      'Thank you for requesting to book {name}. Your provider will respond via email in the next 24 hours.',
  },
  preAuthorizationInfo: {
    id: 'booking.summary.preAuthorizationInfo',
    defaultMessage: 'This is a pre-authorisation only. Full payment will be taken once the booking is confirmed.',
  },
  otherExperiences: {
    id: 'booking.summary.otherExperiences',
    defaultMessage: 'Other experiences',
  },
  seeAllExperiences: {
    id: 'booking.summary.seeAllExperiences',
    defaultMessage: 'See all {count} experiences in {market}',
  },
  seeMoreExperiences: {
    id: 'booking.summary.seeMoreExperiences',
    defaultMessage: 'See more experiences in {market}',
  },
  createAccount: {
    id: 'booking.summary.createAccount',
    defaultMessage: 'Create a Winnow account',
  },
  accountDescription: {
    id: 'booking.summary.accountDescription',
    defaultMessage: 'Create an account to make and manage future bookings.',
  },
  buttonAccountLabel: {
    id: 'booking.summary.buttonAccountLabel',
    defaultMessage: 'Sign up',
  },
});
